import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "content-container"
};
const _hoisted_2 = {
  class: "time"
};
const _hoisted_3 = {
  style: {
    "font-size": "0.9rem"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
import { computed } from 'vue';
export default {
  __name: 'MarketTransactionCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    const propData = computed(() => {
      if (!props.data) return null;
      return props.data.props;
    });
    const propPrice = computed(() => {
      if (!propData.value) return 0.0;
      return parseFloat(propData.value.price).toFixed(1);
    });
    const orderPrice = computed(() => {
      if (!props.data) return 0.0;
      return parseFloat(props.data.order_price).toFixed(1);
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      return propData.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["info-container", `rare-${propData.value?.rare_level}`])
      }, [_createVNode(_component_el_row, {
        style: {
          "justify-content": "space-between",
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_2, [_createElementVNode("b", null, _toDisplayString(__props.data.update_time), 1)]), _createElementVNode("text", _hoisted_3, [_createElementVNode("b", null, [_createTextVNode("- " + _toDisplayString(propPrice.value) + " ", 1), propData.value.type.is_stackable ? (_openBlock(), _createElementBlock("span", _hoisted_4, "  * " + _toDisplayString(__props.data.quantities) + "  = - " + _toDisplayString(orderPrice.value), 1)) : _createCommentVNode("", true)])])]),
        _: 1
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data.buyer?.nickname), 1), _createElementVNode("text", null, " 花费 " + _toDisplayString(propPrice.value) + " 资产点", 1), __props.data.buyer?.id !== __props.data.recipient?.id ? (_openBlock(), _createElementBlock("text", _hoisted_5, " 为 " + _toDisplayString(__props.data.recipient?.nickname) + " ", 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createTextVNode("  购买了  ", -1)), _createElementVNode("span", null, [_createElementVNode("b", null, _toDisplayString(`<${propData.value?.name}>`), 1)]), propData.value.type.is_stackable ? (_openBlock(), _createElementBlock("span", _hoisted_6, "  * " + _toDisplayString(__props.data.quantities), 1)) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_createTextVNode(_toDisplayString(propData.value?.type.desc) + " /  " + _toDisplayString(propData.value?.tag.desc) + " /  ", 1), _createElementVNode("span", {
          class: _normalizeClass(`rare-${propData.value?.rare_level}-tag`)
        }, _toDisplayString(propData.value?.rare_desc), 3)])]),
        _: 1
      })], 2)])) : _createCommentVNode("", true);
    };
  }

};